import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import withTracker from "./../../withTracker";

class AboutApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: undefined,
      data: undefined,
    };
  }

  createMarkup(text) {
    let html = this.state.data.Description || text;
    html = html.split('src="/').join(`src="${window.location.origin}/`);
    return { __html: html };
  }

  parseToHtml(text) {
    return <div dangerouslySetInnerHTML={this.createMarkup(text)} />;
  }

  componentDidMount() {
    if (
      this.props &&
      !this.props.data.data.loading &&
      this.props.data.data.content[1]
    ) {
      this.setState({ loading: false, data: this.props.data.data.content[1] });
    }
  }

  render() {
    return (
      <div className="about">
        <div className="button-top">
          <span>O aplikacji</span>
        </div>
        <main>
          <img className="full" src="/images/img1.png" alt="img" />
          {this.state.data &&
            this.state.data.ProjectSections &&
            this.state.data.ProjectSections.map((section, i) => {
              return (
                <React.Fragment key={i}>
                  <div
                    className={`text-with-bg ${
                      i % 2 !== 0 && "text-with-bg--img"
                    }`}
                    style={{
                      backgroundImage: `url(${
                        i % 2 !== 0 ? `/images/img2.png` : ""
                      })`,
                    }}
                  >
                    <span className="text-with-bg__title">{section.Title}</span>
                    <span className="text-with-bg__desc">
                      {section.Subtitle}
                    </span>
                  </div>
                  {section.Description && (
                    <div className="content-elements">
                      <div className="about-project-info content-element">
                        {this.parseToHtml(section.Description)}
                      </div>
                    </div>
                  )}
                  <div
                    className={`content-elements content-elements-${section.LogotypesRows}`}
                  >
                    {section.Logotypes.map((logotype, i) => {
                      return (
                        <div key={i} className="icon-element">
                          <img
                            src={logotype.url.replace("http://", "https://")}
                            alt="info"
                          />
                          <p>
                            <strong>{logotype.title} </strong>
                          </p>
                          <p>{logotype.description}</p>
                        </div>
                      );
                    })}
                  </div>
                </React.Fragment>
              );
            })}

          <img className="full" src="/images/img3.png" alt="img" />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => (state) => ({
  data: state.Data,
});

export default withTracker(withRouter(connect(mapStateToProps)(AboutApp)));



// WEBPACK FOOTER //
// ./src/js/containers/about-app/index.js